import { DeviceCustomerMode } from '@/__generated__/graphql';
import { t } from '@lingui/macro';
import { z } from 'zod';


export const flowLimitsSchema = z.object({
  deviceId: z.string().min(1, "El campo 'deviceId' no puede estar vacío"),
  state: z.object({
    customerMode: z.nativeEnum(DeviceCustomerMode),
  }),
  flowLimits: z.object({
    min: z
      .any()
      .transform((v) => v !== "" && v != null ? parseFloat(v) : null),
    max: z
      .any()
      .transform((v) => v !== "" && v != null ? parseFloat(v) : null),
  })
  .refine((obj) => {
    if (obj.min != null && obj.max != null) {
      if (obj.max <= obj.min) return false
    }
    return true
  }, { message: t`El mínimo no puede ser mayor o igual al máximo.`, path: ['min'] })
  .refine((obj) => {
    if (obj.max != null) {
      if (obj.max <= 0) return false
    }
    return true
  }, { message: t`El máximo no puede ser menor a 0`, path: ['max'] })
  .refine((obj) => {
    if (obj.min != null) {
      if (obj.min < 0) return false
    }
    return true
  }, { message: t`El mínimo no puede ser menor a 0`, path: ['min'] }),
});
